// System Wallet Saga
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_SYSTEM_WALLET_LIST,
  GET_SYSTEM_WALLET_DATA,
  UPDATE_SYSTEM_WALLET,
  TOPUP_SYSTEM_WALLET,
  GET_SYSTEM_WALLET_TRANSACTIONS,
  ADJUST_SYSTEM_WALLET,
  GET_MY_WALLET,
  GET_MY_WALLET_TRANSACTIONS,
  TOPUP_MY_WALLET,
  UPDATE_MY_WALLET,
  GET_SYSTEM_WALLET_SERVICE_TYPE_LIST,
  CREATE_SYSTEM_WALLET_SERVICE_TYPE,
  UPDATE_SYSTEM_WALLET_SERVICE_TYPE,
  DELETE_SYSTEM_WALLET_SERVICE_TYPE,
  GET_SYSTEM_WALLET_SERVICE_RATE_LIST,
  CREATE_SYSTEM_WALLET_SERVICE_RATE,
  UPDATE_SYSTEM_WALLET_SERVICE_RATE,
  DELETE_SYSTEM_WALLET_SERVICE_RATE,
} from "./actionType";

import {
  getSystemWalletListSuccess,
  getSystemWalletListFailure,
  getSystemWalletDataSuccess,
  getSystemWalletDataFailure,
  updateSystemWalletSuccess,
  updateSystemWalletFailure,
  topUpSystemWalletSuccess,
  topUpSystemWalletFailure,
  getSystemWalletTransactionsSuccess,
  getSystemWalletTransactionsFailure,
  adjustSystemWalletSuccess,
  adjustSystemWalletFailure,
  getMyWalletSuccess,
  getMyWalletFailure,
  getMyWalletTransactionsSuccess,
  getMyWalletTransactionsFailure,
  topUpMyWalletSuccess,
  topUpMyWalletFailure,
  updateMyWalletSuccess,
  updateMyWalletFailure,
  getSystemWalletServiceTypeListSuccess,
  getSystemWalletServiceTypeListFailure,
  createSystemWalletServiceTypeSuccess,
  createSystemWalletServiceTypeFailure,
  updateSystemWalletServiceTypeSuccess,
  updateSystemWalletServiceTypeFailure,
  deleteSystemWalletServiceTypeSuccess,
  deleteSystemWalletServiceTypeFailure,
  getSystemWalletServiceRateListSuccess,
  getSystemWalletServiceRateListFailure,
  createSystemWalletServiceRateSuccess,
  createSystemWalletServiceRateFailure,
  updateSystemWalletServiceRateSuccess,
  updateSystemWalletServiceRateFailure,
  deleteSystemWalletServiceRateSuccess,
  deleteSystemWalletServiceRateFailure,
} from "./action";

import {
  getSystemWalletListApiCall,
  getSystemWalletDataApiCall,
  updateSystemWalletApiCall,
  topUpSystemWalletApiCall,
  getSystemWalletTransactionsApiCall,
  adjustSystemWalletApiCall,
  getMyWalletApiCall,
  getMyWalletTransactionsApiCall,
  topUpMyWalletApiCall,
  updateMyWalletApiCall,
  getSystemWalletServiceTypeListApiCall,
  createSystemWalletServiceTypeApiCall,
  updateSystemWalletServiceTypeApiCall,
  deleteSystemWalletServiceTypeApiCall,
  getSystemWalletServiceRateListApiCall,
  createSystemWalletServiceRateApiCall,
  updateSystemWalletServiceRateApiCall,
  deleteSystemWalletServiceRateApiCall,
} from "../../helpers/fakebackend_helper";

function* getSystemWalletListSaga() {
  try {
    const response = yield call(getSystemWalletListApiCall);
    yield put(getSystemWalletListSuccess(response));
  } catch (error) {
    yield put(getSystemWalletListFailure(error));
  }
}

function* getSystemWalletDataSaga({ payload }) {
  try {
    const response = yield call(getSystemWalletDataApiCall, payload);
    yield put(getSystemWalletDataSuccess(response));
  } catch (error) {
    yield put(getSystemWalletDataFailure(error));
  }
}

function* updateSystemWalletSaga({ payload }) {
  try {
    const response = yield call(updateSystemWalletApiCall, payload);
    yield put(updateSystemWalletSuccess(response));
  } catch (error) {
    yield put(updateSystemWalletFailure(error));
  }
}

function* topUpSystemWalletSaga({ payload }) {
  try {
    const response = yield call(topUpSystemWalletApiCall, payload);
    yield put(topUpSystemWalletSuccess(response));
  } catch (error) {
    yield put(topUpSystemWalletFailure(error));
  }
}

function* getSystemWalletTransactionsSaga({ payload }) {
  try {
    const response = yield call(getSystemWalletTransactionsApiCall, payload);
    yield put(getSystemWalletTransactionsSuccess(response));
  } catch (error) {
    yield put(getSystemWalletTransactionsFailure(error));
  }
}

function* adjustSystemWalletSaga({ payload }) {
  try {
    const response = yield call(adjustSystemWalletApiCall, payload);
    yield put(adjustSystemWalletSuccess(response));
  } catch (error) {
    yield put(adjustSystemWalletFailure(error));
  }
}

function* getMyWalletSaga() {
  try {
    const response = yield call(getMyWalletApiCall);
    yield put(getMyWalletSuccess(response));
  } catch (error) {
    yield put(getMyWalletFailure(error));
  }
}

function* getMyWalletTransactionsSaga() {
  try {
    const response = yield call(getMyWalletTransactionsApiCall);
    yield put(getMyWalletTransactionsSuccess(response));
  } catch (error) {
    yield put(getMyWalletTransactionsFailure(error));
  }
}

function* topUpMyWalletSaga({ payload }) {
  try {
    const response = yield call(topUpMyWalletApiCall, payload);
    yield put(topUpMyWalletSuccess(response));
  } catch (error) {
    yield put(topUpMyWalletFailure(error));
  }
}

function* updateMyWalletSaga({ payload }) {
  try {
    const response = yield call(updateMyWalletApiCall, payload);
    yield put(updateMyWalletSuccess(response));
  } catch (error) {
    yield put(updateMyWalletFailure(error));
  }
}

function* getSystemWalletServiceTypeListSaga() {
  try {
    const response = yield call(getSystemWalletServiceTypeListApiCall);
    yield put(getSystemWalletServiceTypeListSuccess(response));
  } catch (error) {
    yield put(getSystemWalletServiceTypeListFailure(error));
  }
}

function* createSystemWalletServiceTypeSaga({ payload }) {
  try {
    const response = yield call(createSystemWalletServiceTypeApiCall, payload);
    yield put(createSystemWalletServiceTypeSuccess(response));
  } catch (error) {
    yield put(createSystemWalletServiceTypeFailure(error));
  }
}

function* updateSystemWalletServiceTypeSaga({ payload }) {
  try {
    const response = yield call(updateSystemWalletServiceTypeApiCall, payload);
    yield put(updateSystemWalletServiceTypeSuccess(response));
  } catch (error) {
    yield put(updateSystemWalletServiceTypeFailure(error));
  }
}

function* deleteSystemWalletServiceTypeSaga({ payload }) {
  try {
    const response = yield call(deleteSystemWalletServiceTypeApiCall, payload);
    yield put(deleteSystemWalletServiceTypeSuccess(response));
  } catch (error) {
    yield put(deleteSystemWalletServiceTypeFailure(error));
  }
}

function* getSystemWalletServiceRateListSaga() {
  try {
    const response = yield call(getSystemWalletServiceRateListApiCall);
    yield put(getSystemWalletServiceRateListSuccess(response));
  } catch (error) {
    yield put(getSystemWalletServiceRateListFailure(error));
  }
}

function* createSystemWalletServiceRateSaga({ payload }) {
  try {
    const response = yield call(createSystemWalletServiceRateApiCall, payload);
    yield put(createSystemWalletServiceRateSuccess(response));
  } catch (error) {
    yield put(createSystemWalletServiceRateFailure(error));
  }
}

function* updateSystemWalletServiceRateSaga({ payload }) {
  try {
    const response = yield call(updateSystemWalletServiceRateApiCall, payload);
    yield put(updateSystemWalletServiceRateSuccess(response));
  } catch (error) {
    yield put(updateSystemWalletServiceRateFailure(error));
  }
}

function* deleteSystemWalletServiceRateSaga({ payload }) {
  try {
    const response = yield call(deleteSystemWalletServiceRateApiCall, payload);
    yield put(deleteSystemWalletServiceRateSuccess(response));
  } catch (error) {
    yield put(deleteSystemWalletServiceRateFailure(error));
  }
}

export default function* systemWalletSaga() {
  yield all([
    fork(function* () {
      yield takeEvery(GET_SYSTEM_WALLET_LIST, getSystemWalletListSaga);
    }),
    fork(function* () {
      yield takeEvery(GET_SYSTEM_WALLET_DATA, getSystemWalletDataSaga);
    }),
    fork(function* () {
      yield takeEvery(UPDATE_SYSTEM_WALLET, updateSystemWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(TOPUP_SYSTEM_WALLET, topUpSystemWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(
        GET_SYSTEM_WALLET_TRANSACTIONS,
        getSystemWalletTransactionsSaga
      );
    }),
    fork(function* () {
      yield takeEvery(ADJUST_SYSTEM_WALLET, adjustSystemWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(GET_MY_WALLET, getMyWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(GET_MY_WALLET_TRANSACTIONS, getMyWalletTransactionsSaga);
    }),
    fork(function* () {
      yield takeEvery(TOPUP_MY_WALLET, topUpMyWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(UPDATE_MY_WALLET, updateMyWalletSaga);
    }),
    fork(function* () {
      yield takeEvery(
        GET_SYSTEM_WALLET_SERVICE_TYPE_LIST,
        getSystemWalletServiceTypeListSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        CREATE_SYSTEM_WALLET_SERVICE_TYPE,
        createSystemWalletServiceTypeSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        UPDATE_SYSTEM_WALLET_SERVICE_TYPE,
        updateSystemWalletServiceTypeSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        DELETE_SYSTEM_WALLET_SERVICE_TYPE,
        deleteSystemWalletServiceTypeSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        GET_SYSTEM_WALLET_SERVICE_RATE_LIST,
        getSystemWalletServiceRateListSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        CREATE_SYSTEM_WALLET_SERVICE_RATE,
        createSystemWalletServiceRateSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        UPDATE_SYSTEM_WALLET_SERVICE_RATE,
        updateSystemWalletServiceRateSaga
      );
    }),
    fork(function* () {
      yield takeEvery(
        DELETE_SYSTEM_WALLET_SERVICE_RATE,
        deleteSystemWalletServiceRateSaga
      );
    }),
  ]);
}
